<template>
    <DetailsPane title="Event Details" :hide-close="true" :auto-height="true">
        <div class="event-details p-4">
            <div class="row mb-2">
                <div class="col-4 col-attribute">Event ID:</div>
                <div class="col-8 col-value">{{ event.id }}</div>
            </div>
            <div class="row mb-2">
                <div class="col-4 col-attribute">Date/Time:</div>
                <div class="col-8 col-value" v-html="event.dateAndTime"></div>
            </div>
            <div class="row mb-2">
                <div class="col-4 col-attribute">Sponsor:</div>
                <div class="col-8 col-value">{{ event.sponsor_name }}</div>
            </div>
            <div class="row mb-2">
                <div class="col-4 col-attribute">Brand:</div>
                <div class="col-8 col-value">{{ event.brand }}</div>
            </div>
            <div class="row mb-2">
                <div class="col-4 col-attribute">Local Contact:</div>
                <div class="col-8 col-value" v-html="localContact"></div>
            </div>
            <div class="row mb-2">
                <div class="col-4 col-attribute">Trainer(s):</div>
                <div v-if="!!event.course.authorized_training" class="col-8 col-value">
                    Authorized Training Certified Trainer
                </div>
                <div v-else class="col-8 col-value" v-html="trainer"></div>
            </div>
            <div class="row mb-2">
                <div class="col-4 col-attribute">No Enrolled:</div>
                <div class="col-8 col-value">{{ event.num_enrolled }}</div>
            </div>
            <div class="row mb-2">
                <div class="col-4 col-attribute">Max Enrollment:</div>
                <div class="col-8 col-value">{{ event.max_attendees }}</div>
            </div>
            <div class="row mb-2">
                <div class="col-4 col-attribute">Location:</div>
                <div class="col-8 col-value" v-html="event.address" />
            </div>
            <div class="row mb-2">
                <div class="col-4 col-attribute">Ship Materials To:</div>
                <div class="col-8 col-value" v-html="event.shippingAddress" />
            </div>
            <div class="row mb-2">
                <div class="col-4 col-attribute">Additional Notes:</div>
                <div class="col-12 col-value mt-2" v-html="event.notes"></div>
            </div>
        </div>
    </DetailsPane>
</template>
<script>
import DetailsPane from "components/listings/DetailsPane";

export default {
    props: {
        event: { type: Object, required: true },
    },

    components: {
        DetailsPane,
    },

    computed: {
        localContact() {
            let contact = this.event.contact.name;

            if (!!this.event.contact.email) {
                contact = `<a href="mailto:${this.event.contact.email}" class="text-primary">${contact}</a>`;
            }

            contact += `<br>${this.event.contact.company.name}`;

            if (!!this.event.contact.company.phone) {
                contact += `<br>${this.event.contact.company.phone}`;
            }

            return contact;
        },

        trainer() {
            let trainer = "";

            this.event.trainers.forEach((t, i) => {
                if (i > 0) trainer += `<br><br>`;
                trainer += t.name;
                trainer += `<br>${t.company.name}`;
                if (!!t.company.phone) trainer += `<br>${t.company.phone}`;
            });

            return trainer;
        },
    },
};
</script>
<style lang="scss" scoped>
.event-details {
    font-size: 0.875rem;
    .col-attribute {
        color: #666666;
    }
}
</style>
